module.exports = __webpack_public_path__ + "static/media/spinner-circle.b74a4dd2.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/spinner-circle.svg
// module id = 205
// module chunks = 0